var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.v),expression:"v"}],domProps:{"value":(_vm.v)},on:{"focus":_vm.onFocus,"blur":_vm.onBlur,"keydown":_vm.onKeydown,"input":function($event){if($event.target.composing)return;_vm.v=$event.target.value}}})
}
var staticRenderFns = []

export { render, staticRenderFns }